import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { truncateString } from "utils/UtilityFuncs";

export default function EfsLicense() {
  /* ******************** All States ************************* */
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [efsLicense, setEfsLicense] = useState(null);

  const [showCrudModal, setShowCrudModal] = useState(false);
  const [formData, setFormData] = useState({ efsLicense: "" });
  const [isEditMode, setIsEditMode] = useState(false);

  /* ******************** All Functions ************************* */

  const getEfsLicense = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/manufacturer/efs-license", {
        headers: authHeader(),
      });
      if (data?.success) {
        setEfsLicense([
          {
            id: 1,
            efsLicense: data.licenseId,
            limit: data.limit,
            sro: data.sro,
          },
        ]);
      } else {
        setEfsLicense(null);
        dispatch(
          setNotification({
            message: data?.message || "Failed to fetch EFS License",
            type: "error",
          })
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const handleOpenAddModal = () => {
    setFormData({ efsLicense: "", limit: "", sro: "" });
    setIsEditMode(false);
    setShowCrudModal(true);
  };

  const handleOpenEditModal = (item) => {
    setFormData({
      efsLicense: item.efsLicense || "",
      limit: item.limit || "",
      sro: item.sro || "",
    });
    setIsEditMode(true);
    setShowCrudModal(true);
  };

  const handleCloseModal = () => {
    setShowCrudModal(false);
    setFormData({ efsLicense: "", limit: "", sro: "" });
    setIsEditMode(false);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log(formData);

      setLoading(true);
      if (isEditMode) {
        // Update API call
        await API.patch(`/manufacturer/efs-license`, formData, {
          headers: authHeader(),
        });
        dispatch(
          setNotification({
            message: "License updated successfully",
            type: "success",
          })
        );
      } else {
        // Create API call
        await API.post("/manufacturer/efs-license", formData, {
          headers: authHeader(),
        });
        dispatch(
          setNotification({
            message: "License added successfully",
            type: "success",
          })
        );
      }
      handleCloseModal();
      getEfsLicense();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /* ******************** All UseEffects ************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      getEfsLicense();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /* ******************** Table Functions ************************* */

  const addButton = () => (
    <>
      <button className="btn btn-primary ms-1" onClick={handleOpenAddModal}>
        <i className="mdi mdi-plus me-1"></i>Add License
      </button>
    </>
  );

  const table_head = ["License ID", "Limit", "SRO", "Actions"];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="align-middle py-1">
        {truncateString(item.efsLicense, 40)}
      </td>
      <td className="align-middle py-1">{truncateString(item.limit, 30)}</td>
      <td className="align-middle py-1">{item.sro}</td>
      <td className="align-middle py-1 text-end table-action">
        <button
          disabled={loading}
          onClick={() => {
            handleOpenEditModal(item);
          }}
          className="btn btn-sm px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>
      </td>
    </tr>
  );

  return (
    <div>
      {loading && <Spinner />}
      <div className="">
        <Table
          btnLeft={(e) => {
            return <h3 className="">Efs License</h3>;
          }}
          btn1={addButton}
          table_head={table_head}
          table_body={table_body}
          actionsOnEnd={true}
          table_data={efsLicense || []}
        />
      </div>
      <Modal show={showCrudModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit License" : "Add License"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="efsLicense" className="form-label">
                EFS License
              </label>
              <input
                type="text"
                className="form-control"
                id="efsLicense"
                name="efsLicense"
                value={formData.efsLicense}
                onChange={handleInputChange}
                required
                placeholder="Enter EFS License"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="efsLicense" className="form-label">
                Limit
              </label>
              <input
                type="text"
                className="form-control"
                id="limit"
                name="limit"
                value={formData.limit}
                onChange={handleInputChange}
                required
                placeholder="Enter Limit"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="sro" className="form-label">
                SRO
              </label>
              <input
                type="text"
                className="form-control"
                id="sro"
                name="sro"
                value={formData.sro}
                onChange={handleInputChange}
                required
                placeholder="Enter SRO"
              />
            </div>
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseModal}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
